export default {"src":"/_next/static/media/segway.a26c6731.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};